<div class="image-background">
	<h1 class="header_text_wrapper text-left"><span>Map</span><span class="separator"></span></h1>
</div>
<div class="page-content">
    <div class="container-fluid">
        <section class="vc_section vc_custom_1497969368387 vc_section-has-fill" style="">
            <div class="row home_block_box_bg">
                <div class="gmap wpb_column column-style-1 col-md-8 col-12">
                    <div class="vc_column-inner ">
                        <div class="wpb_wrapper">
                            <div class="wpb_text_column wpb_content_element ">
                                <div class="wpb_wrapper">
                                    <p style="padding: 15px;">
                                        <iframe style="border: 0;" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.9031390761616!2d77.61945311482003!3d12.784798890978651!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae6962fb4cf27f%3A0x6c74f546ddbaf7c0!2sMango+Mist+Resorts!5e0!3m2!1sen!2sin!4v1545470856598" width="745" height="800" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wpb_column col-md-4 col-12">
                    <div class="vc_column-inner ">
                        <div class="wpb_wrapper">
                            <div class="calluna-highlight calluna-highlight-blue ">Location Map</div>
                            <div class="wpb_text_column wpb_content_element ">
                                <div class="wpb_wrapper">
                                    <p class="style89 style95" align="left"><span class="style75 style59 style60">Via Bannerghatta: <a href="https://www.google.com/maps?saddr=Bannerghatta+Road,+Phase+III,+J+P+Nagar,+Bangalore,+Karnataka,+India&amp;daddr=Mango+Mist+Resorts,+Bengaluru,+Karnataka,+India&amp;hl=en&amp;ll=12.848624,77.602272&amp;spn=0.229287,0.41851&amp;sll=12.892135,77.612572&amp;sspn=0.229247,0.41851&amp;geocode=FTkCxQAdMhWgBClVWCVZBxWuOzFVYj0JQ3D8Xw%3BFSMawwAdUWqgBCF8oyeMjbLFMikv3l_0YmmuOzF8oyeMjbLFMg&amp;oq=bann&amp;mra=ls&amp;t=m&amp;z=12" target="_new">(Click here)</a></span></p>
                                    <p class="style89 style95" align="left"><span class="style75 style59 style60">Via Electronic City:</span> <a href="http://www.google.com/maps?saddr=Electronics+City,+Bengaluru,+Karnataka,+India&amp;daddr=12.7869581,77.6363038+to:Mango+Mist+Resorts,+Bengaluru,+Karnataka,+India&amp;hl=en&amp;sll=12.809458,77.655315&amp;sspn=0.096584,0.169086&amp;geocode=FQPswwAdy0GhBCnD4VB3imyuOzEd91rOD_xcSg%3BFQ4dwwAdz6KgBCkdsrlqX2muOzErMsI1alhbRA%3BFSMawwAdUWqgBCF8oyeMjbLFMg&amp;mra=dvme&amp;mrsp=1&amp;sz=13&amp;via=1&amp;t=m&amp;z=13" target="_new">(Click here)</a></p>
                                    <p class="style74 style89 style91" align="left"><span class="style75 style58 style96">Transportation</span></p>
                                    <p class="style74 style89 style91" align="left"><span class="style70 style59"><span class="style60">By Car :</span></span><span class="style95">Majestic- MangoMist(Distance~25KM)</span></p>
                                    <p class="style74 style89 style91" align="left"><span class="style70 style59"><span class="style60">Taxi</span></span> :</p>
                                    <p class="style74 style89 style91" align="left"><span class="style95">Please <a href="http://bookings.mangomist.com/connect.php">contact us</a></span></p>
                                    <p class="style74 style89 style91" align="left"><span class="style70 style59"><span class="style60">Public Transport</span></span> :</p>
                                    <p class="style74 style89 style91" align="left"><span class="style95">Majestic- Bannerghatta Circle:Bmtc Volvo Bus No V365(~20Km)</span></p>
                                    <p class="style74 style89 style91" align="left"><span class="style95">Bannerghatta-Harapanahalli :Can travel by a Rickshaw / local Bmtc </span>(~5Km)</p>
                                    <p class="style74 style89 style91" align="left"><span class="style70 style59"><span class="style60">Address</span> :</span>
                                    </p>
                                    <p class="style74 style89 style91" align="left"><span class="style89 style95">Mango Mist Resorts; Sy No 33,37; Harapanahalli; Jigani Hobli; Anekal Taluk Bengaluru; Karnataka; India. PIN-560105</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="vc_row-full-width vc_clearfix"></div>
        <div class="vc_row wpb_row vc_row-fluid" style="height:0">
            <div class="wpb_column vc_column_container vc_col-sm-12"></div>
        </div>
    </div>
</div>

<style>
    .page-content {
		background: rgba(0, 0, 0, 0) url('../images/gpattern-opacity-1.png') repeat scroll 0 0;
	}

    .image-background {
        background: url("../images/Map.jpg") no-repeat center;
    }
    
    .home_block_box_bg {
        -moz-border-bottom-colors: none;
        overflow: hidden;
        -moz-border-left-colors: none;
        -moz-border-right-colors: none;
        -moz-border-top-colors: none;
        background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
        border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
        border-image: none;
        border-radius: 25px;
        box-shadow: 8px 8px 8px #888888;
    }

    iframe {
        width: 100%;
    }

</style>